import { ArrowLeftRight, Hexagon, Palette } from "lucide-react";
import { COMPARISON_ROWS } from "@/lib/partnership";

export default function Comparison() {
  return (
    <div className="space-y-6" data-testid="comparison-page">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-zinc-100 flex items-center gap-3">
          <ArrowLeftRight className="w-7 h-7 text-emerald-400" strokeWidth={1.5} /> Standalone vs Embedded — Comparison
        </h1>
        <p className="text-sm text-zinc-400 mt-1 max-w-3xl">
          How the two demonstration modes differ across the dimensions that matter to a CRM technology provider.
          Commercial structures are indicative only — no pricing is shown or implied.
        </p>
      </div>

      <div className="bg-zinc-900 border border-zinc-800 rounded-md overflow-x-auto">
        <table className="w-full text-sm min-w-[900px]" data-testid="comparison-table">
          <thead>
            <tr className="border-b border-zinc-800 text-left">
              <th className="px-6 py-4 text-[11px] font-semibold text-zinc-500 uppercase tracking-wider w-48">Dimension</th>
              <th className="px-6 py-4">
                <div className="flex items-center gap-2">
                  <Hexagon className="w-4 h-4 text-emerald-400" strokeWidth={1.5} />
                  <span className="text-xs font-semibold text-zinc-100">Mode 1 — O.N.E.Tech Standalone</span>
                </div>
              </th>
              <th className="px-6 py-4">
                <div className="flex items-center gap-2">
                  <Palette className="w-4 h-4 text-emerald-400" strokeWidth={1.5} />
                  <span className="text-xs font-semibold text-zinc-100">Mode 2 — Embedded / White-Label</span>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {COMPARISON_ROWS.map((row, i) => (
              <tr key={row.dimension} className={`border-b border-zinc-800/60 hover:bg-zinc-800/40 transition-colors duration-150 ${i % 2 ? "bg-zinc-950/40" : ""}`} data-testid={`comparison-row-${i}`}>
                <td className="px-6 py-4 text-xs font-semibold text-zinc-100 align-top">{row.dimension}</td>
                <td className="px-6 py-4 text-xs text-zinc-400 leading-relaxed align-top">{row.standalone}</td>
                <td className="px-6 py-4 text-xs text-zinc-400 leading-relaxed align-top">{row.embedded}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="border border-amber-500/20 bg-amber-500/5 rounded-sm px-4 py-3 text-[11px] font-mono text-amber-500/90" data-testid="comparison-disclaimer">
        No prices are displayed. Commercial terms, support SLAs and revenue structures are defined during partner evaluation — nothing on this page constitutes a legal or commercial commitment.
      </div>
    </div>
  );
}
